import { render, staticRenderFns } from "./single-service.vue?vue&type=template&id=2827b429&"
import script from "./single-service.vue?vue&type=script&lang=js&"
export * from "./single-service.vue?vue&type=script&lang=js&"
import style0 from "./single-service.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports